/**
 * 道交法違反検知ページ用のスクリプト
 */
if (is_route('navitime_analysis.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        navitime_analysis_event_set();
        navitime_analysis_video_event_set();
    });
}
if (is_route('navitime_analysis.result_index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        navitime_analysis_result_event_set();
        navitime_analysis_video_event_set();
    });
}

// === 全画面切り替え（ページロード時に1回だけバインド） ===
(function() {
    if (window._videoFullscreenBound) return;
    window._videoFullscreenBound = true;

    var fsElement = function() {
        return document.fullscreenElement
            || document.webkitFullscreenElement
            || document.msFullscreenElement;
    };
    var requestFs = function(el) {
        if (el.requestFullscreen) return el.requestFullscreen();
        if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
        if (el.msRequestFullscreen) return el.msRequestFullscreen();
    };
    var exitFs = function() {
        if (document.exitFullscreen) return document.exitFullscreen();
        if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
        if (document.msExitFullscreen) return document.msExitFullscreen();
    };

    // メイン動画を直接全画面化（ネイティブコントロール表示）
    $(document).on('click', '.video-fullscreen-btn', function() {
        var mainVideo = document.getElementById('main-video');
        if (!mainVideo) return;

        if (!fsElement()) {
            mainVideo.setAttribute('controls', '');
            requestFs(mainVideo);
        } else {
            exitFs();
        }
    });

    function onFullscreenChange() {
        var btn = document.querySelector('.video-fullscreen-btn i');
        var mainVideo = document.getElementById('main-video');
        if (btn) {
            btn.className = fsElement() ? 'fa fa-compress' : 'fa fa-expand';
        }
        // 全画面解除時: ネイティブコントロールを消し、全 video / audio の再生位置と再生状態を main-video に揃える
        if (!fsElement() && mainVideo) {
            mainVideo.removeAttribute('controls');
            var wasPlaying = !mainVideo.paused;
            // ドリフト防止: main-video が再生中なら直接 pause（ネイティブコントロール経由の play promise は既に解決済みのはずなので AbortError は出ない）
            mainVideo.pause();
            // モーダル側の状態を「全停止 / isPlaying=false / ボタン=再生表示」にリセット
            // （wasPlaying=true 後続の #video-play 経路で play() が確実に走らせるため isPlaying を一旦下げる）
            $('#video-pause').trigger('click');
            // 全 video / audio に main-video の currentTime を伝播
            var currentTime = mainVideo.currentTime;
            document.querySelectorAll('.in-vehicle-video').forEach(function(video) {
                if (video !== mainVideo) {
                    video.currentTime = currentTime;
                }
            });
            var audio = document.getElementById('in-vehicle-audio');
            if (audio) {
                audio.currentTime = currentTime;
            }
            // 再生中だった場合は #video-play 経由で全 video / audio を再生再開
            // （play() 呼び出しは1経路に集約され、AbortError 系の race も最小化される）
            if (wasPlaying) {
                $('#video-play').trigger('click');
            }
            // シークバー・現在時間表示・地図マーカーは timeline-video の timeupdate 駆動のため、明示的に発火させる
            var timeline = document.getElementById('timeline-video');
            if (timeline) {
                timeline.dispatchEvent(new Event('timeupdate'));
            }
        }
    }
    document.addEventListener('fullscreenchange', onFullscreenChange);
    document.addEventListener('webkitfullscreenchange', onFullscreenChange);
    document.addEventListener('MSFullscreenChange', onFullscreenChange);
})();

/**
 * ページ読み込み時のイベント設定
 */
window.navitime_analysis_event_set = function () {

    /*---- ページタブ切り替え時 ----*/

    // タブ切り替え時
    $(document).on('click', '[data-page-type]', function() {
        $('#search-form-type').val($(this).data('page-type')).trigger('change');
    });

    /*---- 検索条件変更時 ----*/

    // 入力日時（開始）変更時
    $(document).on('change', '#search-form-end_time_from', function () {
        let last_day = null;
        selected_date = $(this).val();
        set_end = $('#search-form-end_time_to').val();
        if(set_end != ''){
            selected_date = new Date(selected_date);
            chk_date_over = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
            chk_date = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate());
            set_end = new Date(set_end);
            yyyymmdd = new Date(set_end.getFullYear(),set_end.getMonth(),set_end.getDate());
            if(chk_date_over.getTime() < yyyymmdd.getTime()){
                yyyymmdd = new Date(selected_date.getFullYear(),selected_date.getMonth(),selected_date.getDate() + 31);
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }else if(chk_date.getTime() > yyyymmdd.getTime()){
                last_day = chk_date.getFullYear()+'/'+
                        ( "0"+( chk_date.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+chk_date.getDate() ).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }
        }
    });

    // 入力日時（終了）変更時
    $(document).on('change', '#search-form-end_time_to', function () {
        let last_day = null;
        selected_date = $(this).val();
        set_start = $('#search-form-end_time_from').val();
        if(set_start != ''){
            selected_date = new Date(selected_date);
            set_start = new Date(set_start);
            yyyymmdd = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate() + 31);
            yyyymmdd_2 = new Date(set_start.getFullYear(),set_start.getMonth(),set_start.getDate());
            if(selected_date.getTime() > yyyymmdd.getTime()){
                last_day = yyyymmdd.getFullYear()+'/'+
                        ( "0"+( yyyymmdd.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd.getDate() ).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }else if(selected_date.getTime() < yyyymmdd_2.getTime()){
                last_day = yyyymmdd_2.getFullYear()+'/'+
                        ( "0"+( yyyymmdd_2.getMonth()+1 ) ).slice(-2)+'/'+
                        ( "0"+yyyymmdd_2.getDate() ).slice(-2);
                $('#search-form-end_time_to').val(last_day);
            }
        }
    });

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let data = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, data);
    });

    /*---- 解析依頼ボタン押下時 ----*/

    // 解析依頼ボタン押下時
    $(document).on('click', '#navitime_diagnosis_button', function () {
        let action = $(this).data('action');
        let data = [];
        // データを追加
        data.push({'name' : 'id', 'value' : $(this).data('id')});
        data.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        // 送信前にエラーをリセット
        _error.reset()
        if (confirm("解析依頼を行いますがよろしいですか？")) {
            _ajax.post(action, data, function (results) {
                // 完了メッセージをセットする
                _complete.set(results);
                // コンテンツの読込
                load_contents();
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });
        }
    });

    /*---- 解析結果表示ボタン押下時 ----*/

    // 解析結果表示ボタン押下時
    $(document).on('click', '#navitime_result_button', function () {
        // データを追加
        let data = [];
        data.push({'name' : 'id', 'value' : $(this).data('id')});
        data.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        data.push({'name' : 'company_id', 'value' : $(this).data('company_id')});
        data.push({'name' : 'section_id', 'value' : $(this).data('section_id')});
        data.push({'name' : 'end_time_from', 'value' : $(this).data('end_time_from')});
        data.push({'name' : 'end_time_to', 'value' : $(this).data('end_time_to')});
        data.push({'name' : 'type', 'value' : $(this).data('type')});
        // アクションの取得
        let action = $(this).data('action');
        url = _request.create_url(action, data);
        // 生成したURLへリダイレクト
        location.href = url;
    });

    /*---- 日報出力ボタン押下時 ----*/

    // 日報出力ボタン押下時
    $(document).on('click', '#navitime_printingreport_button', function () {
        // 検索フォームを配列化
        let data = [];
        // データを追加
        data.push({'name' : 'id', 'value' : $(this).data('id')});
        data.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        data.push({'name' : 'company_id', 'value' : $(this).data('company_id')});
        data.push({'name' : 'section_id', 'value' : $(this).data('section_id')});
        data.push({'name' : 'record_id', 'value' : $(this).data('record_id')});
        // BlobでPDFを別ウィンドウで表示
        _ajax.blob($(this).data('action'), data, function (blob) {
            window.open(window.URL.createObjectURL(blob), '_blank');
        }, function(xhr, status, errorThrown){
            _error.omitted(xhr, status, errorThrown);
        });
    });
}

window.navitime_analysis_video_event_set = function () {
    // 動画表示用モーダルを表示する
    $(document).on('click', '[data-video-modal]', function () {
        _modal.create(this, 'video-modal', ['warning_id','record_id','holding_id','company_id','unit'], false, function(){
            navitime_analysis_modal_event_set();
        });
    });

    // タグ・コメント編集用のモーダルを表示する
    $('[data-tagCommentEdit-modal]').off('click');
    $(document).on('click', '[data-tagCommentEdit-modal]', function () {
        //warningテーブルからデータを取得する
        let action = extend_url_query($(this).data('action'));
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'warning_id',value:$('#tag_comment_edit-btn').data('warning_id')},
            {name:'holding_id',value:$('#user-holding-config').children('span').data('replace-name-holding-id')},
        ];
        // 送信
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                let tagArray = [];
                let tags = data.tag;
                tags.forEach(function(tag) {
                    tagArray.push(tag);
                })
                $('#editform-tag').val(tagArray).trigger('change');
                $('#editform-comment').val(data.comment);
                _modal.show('#tagCommentEdit-modal');
            },
            error: function(jqXHR) {
                const errorMessage = jqXHR.responseJSON ? jqXHR.responseJSON.error : 'An error occurred.';
                toastr.error('Error: ' + errorMessage);
            }
        });
    });

    let editFormId = '#editform-';
    //タグ・コメントをDBに登録する
    $(document).on('click', '#editform-submit', function () {
        $(editFormId + 'tag').removeClass('is-invalid');
        $(editFormId + 'tag-errors').children('span').addClass('copy').text('');
        $(editFormId + 'comment').removeClass('is-invalid');
        $(editFormId + 'comment-errors').children('span').addClass('copy').text('');
        let action = extend_url_query($(this).data('action'));
        let multipleselect = [];
        $('#editform-tag option:selected').each(function() {
            multipleselect.push($(this).val());
        });
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'warning_id',value:$('#tag_comment_edit-btn').data('warning_id')},
            {name:'holding_id',value:$('#user-holding-config').children('span').data('replace-name-holding-id')},
            {name:'inputTag',value:$('#editform-tag').val()},
            {name:'inputComment',value:$('#editform-comment').val()},
        ];
        // 送信
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                toastr.success(data.message);
            },
            error: function(xhr) {
                $.each(xhr.responseJSON.errors, function(name, message) {

                    $(editFormId + name).addClass('is-invalid');
                    $(editFormId + name +'-errors').children('span').removeClass('copy').text(message);
                });
                const errorMessage = xhr.responseJSON.subject ? xhr.responseJSON.subject : 'エラー内容を確認してください。';
                toastr.error(errorMessage);
            }
        });
    });

    $('#editform-tag_plus').off('click');
    $(document).on('click', '#editform-tag_plus', function () {
        //タグデータの登録を行う
        let action = extend_url_query($(this).data('action'));
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'warning_id',value:$('#tag_comment_edit-btn').data('warning_id')},
        ];
        // 送信
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                $('#add_tag-modal').find('.modal-content').empty();
                $('#add_tag-modal').find('.modal-content').append(data);
                _modal.show('#add_tag-modal');
            },
            error: function(jqXHR) {
                const errorMessage = jqXHR.responseJSON ? jqXHR.responseJSON.error : 'An error occurred.';
                toastr.error('Error: ' + errorMessage);
            }
        });
    });

    //タグの追加処理
    let addFormId = '#tag_add_form-';
    $(document).on('click', '#tag_add_form-submit', function () {
        $(addFormId + 'holding_id').removeClass('is-invalid');
        $(addFormId + 'holding_id-errors').children('span').addClass('copy').text('');
        $(addFormId + 'company_id').removeClass('is-invalid');
        $(addFormId + 'company_id-errors').children('span').addClass('copy').text('');
        $(addFormId + 'content1').removeClass('is-invalid');
        $(addFormId + 'content1-errors').children('span').addClass('copy').text('');
        let action = extend_url_query($(this).data('action'));
        let datas = [
            {name:'_token',value:$('input[name="_token"]').val()},
            {name:'holding_id',value:$(addFormId + 'holding_id').val()},
            {name:'company_id',value:$(addFormId + 'company_id').val()},
            {name:'content1',value:$(addFormId + 'content1').val()},
        ];
        // 送信
        $.ajax({
            url: action,
            type: 'POST',
            data: datas,
            success: function(data, status, xhr) {
                $('#editform-tag').append($('<option>').html(data.content1).val(data.id));
                toastr.success(data.message);
            },
            error: function(xhr) {
                $.each(xhr.responseJSON.errors, function(name, message) {
                    $(addFormId + name).addClass('is-invalid');
                    console.log(addFormId + name);
                    $(addFormId + name +'-errors').children('span').removeClass('copy').text(message);
                });
                const errorMessage = xhr.responseJSON.subject ? xhr.responseJSON.subject : 'エラー内容を確認してください。';
                toastr.error(errorMessage);
            }
        });
    });

    // モーダル内動画ダウンロード
    $(document).on('click', '#modal_download_video_button', function () {

        if($('#user-holding-config').children('span').data('replace-name-holding-id').length <= 0) {
            toastr.warning('グループ会社が選択されていません。');
        } else {
            // アクションの取得
            let action = extend_url_query($(this).data('action'));
            let id = $(this).data('id');
            // 一覧にあるデータのチェックされたものを配列化する
            let ids = [id];

            let datas = [
                {name:'_token',value:$('input[name="_token"]').val()},
                {name:'holding_id',value:$('#user-holding-config').children('span').data('replace-name-holding-id')},
                {name:'ids',value:ids},
                {name:'modal_download',value:true}
            ];
            // 送信
            $.ajax({
                url: action,
                type: 'POST',
                data: datas,
                xhrFields: {
                    responseType: 'blob' // レスポンスをBlobとして処理する
                },
                success: function(data, status, xhr) {
                    const disposition = xhr.getResponseHeader('Content-Disposition');
                    if (disposition && disposition.indexOf('attachment') !== -1) {
                        const match = disposition.match(/filename\*\s*=\s*UTF-8''(.+?)(?:;|$)/i);
                        const filename = decodeURIComponent(match[1]);
                        const blob = new Blob([data], { type: xhr.getResponseHeader('Content-Type') });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        toastr.error('File download failed.');
                    }
                },
                error: function(jqXHR) {
                    const errorMessage = jqXHR.responseJSON ? jqXHR.responseJSON.error : 'An error occurred.';
                    toastr.error('Error: ' + errorMessage);
                }
            });
        }
    });
}

/**
 * ページ読み込み時のイベント設定
 */
window.navitime_analysis_result_event_set = function () {

    /*---- 一覧に戻るボタン押下時 ----*/

    // 一覧に戻るボタン押下時
    $(document).on('click', '#navitime_analysis-list-button', function () {
        let self = $(this);
        // 検索条件を配列化
        let params = ['holding_id', 'company_id', 'section_id', 'end_time_from', 'end_time_to', 'type', 'driver_code', 'driver_id', 'vehicle_code', 'vehicle_id', 'report_number'];
        let data = [];
        // データを追加
        params.forEach(function(param) {
            if (self.data(param) != null && self.data(param) != '' ) {
                data.push({'name' : param, 'value' : self.data(param)});
            }
        });
        // アクション取得
        action = self.data('action');
        url = _request.create_url(action, data);
        // 生成したURLへリダイレクト
        location.href = url;
    });

    window.view_map = function (lat, lon, time, msg){
        var options = {
            latitude:   lat,       // 緯度
            longitude:  lon,      // 経度
            //radius:     radius,         // 半径
            mapZoom:    12,             // ズーム倍率
            time: time, // 吹き出し
            msg: msg, // 吹き出し
        };
        $("#menu_ZMap").mapCommon(options);
    }

    $(function(){
        $(".sticky-content").parents().css("overflow", "visible")

        $('.datepicker').datepicker({
            language: '{{App::getLocale()}}',
            autoclose: true,
            format: 'yyyy-mm-dd',
            clearBtn: true,
            todayHighlight: true,
        })

        $(document).on('modal_regist_destination:closed',function(e, type, rowid, results){
            if (results && results.input){
                location.href='/admin/service/edit?' + 'holding_id=' + results.input.holding_id + '&company_id=' + results.input.company_id + '&section_id=' + results.input.section_id
                + '&record_id=' + results.input.record_id + '&start_time=' + results.input.start_time + '&end_time=' + results.input.end_time;
            }
        });

        // 動画要求
        $(".modal-drareco-open").click(function(){
            var holding_id = $('#modal_holding_id').val();
            var holding_name = $('#modal_holding_name').val();
            var company_id = $('#modal_company_id').val();
            var company_name = $('#modal_company_name').val();
            var section_id = $('#modal_section_id').val();
            var section_name = $('#modal_section_name').val();
            var start_time = $('#service_start').val();
            var end_time = $('#service_end').val();
            var vehicle_id = $('#modal_vehicle_id').val(); // 車両ID
            var vehicle_code = $('#modal_vehicle_code').val(); // 車両コード
            var vehicle_name = $('#modal_vehicle_name').val(); // 車両番号

            var record_id = $(this).data('service');
            var latitude = $(this).data('latitude');        // 経度
            var longitude = $(this).data('longitude');      // 緯度
            var event_time = $(this).data('event_time')// 発生日時(raw)
            var event_type = 3; // イベント区分
            var event_id = $(this).data('event_id'); // イベント種別ID
            var rowid = $(this).data('rowid');
            var comment = $(this).data('comment');      // こめんと

            // warningテーブルのIDを渡すため、値を加工
            rowid = '3_' + rowid;

            let params = {
                type: 1,    // 日報修正には不要のため1を設定
                rowid: rowid,
                record_id: record_id,
                holding_id: holding_id,
                company_id: company_id,
                section_id: section_id,
                section_name: section_name,
                vehicle_id: vehicle_id,
                vehicle_code: vehicle_code,
                vehicle_name: vehicle_name,
                event_time: event_time,
                event_type: event_type,
                event_id: event_id,
                latitude: latitude,
                longitude: longitude,
                comment: comment,
            };
            console.log(params);
            showModalDriveRecorderDetail(params);
        });
    });

    /*---- 動画要求時 ----*/

    // 動画要求ボタン押下時
    $(document).on('click', '[data-request-video-modal]', function () {
        // パラメタ編集
        let params = [];
        params.push({'name' : 'holding_id', 'value' : $(this).data('holding_id')});
        params.push({'name' : 'company_id', 'value' : $(this).data('company_id')});
        params.push({'name' : 'section_id', 'value' : $(this).data('section_id')});
        params.push({'name' : 'vehicle_id', 'value' : $(this).data('vehicle_id')});
        params.push({'name' : 'request_video_time', 'value' : $(this).data('request_video_time')});
        _modal.create_with_data(this, 'request-video-modal', params, true, null);
    });

    // 動画要求時
    $(document).on('click', '[data-request-video-save-modal]', function () {
        _modal.submit(this, 'request-video-save-modal');
    });

    /////////////////////////////////////
    // 地図操作関連
    /////////////////////////////////////

    $(function () {

        let url_get_movement_map_data   = "{!! route('movement_map.get_movement_map_data') !!}";
        let url_set_layout_type_data    = "{!! route('movement_common.set_layout_type_data') !!}";
        let url_temporary_return_list   = "{!! route('temp_return.list') !!}";                                  // 仮帰庫検索結果一覧のURL
        let url_save_request_behavior_data  = "{!! route('movement_common.save_request_behavior_data') !!}";    // 動態要求データ登録処理のURL
        let url_save_request_video_data     = "{!! route('movement_common.save_request_video_data') !!}";       // 動画要求データ登録処理のURL
        let url_set_default_map_position_data = "{!! route('movement_common.set_default_map_position_data') !!}";
        let url_get_destination_areas   = "{!! route('movement_common.get_destination_areas') !!}";

        // let movement_base               = JSON.parse(sanitaize.decode("{{ json_encode(__('movement/movement_base'), true) }}"));
        // let movement_map                = JSON.parse(sanitaize.decode("{{ json_encode(__('movement/movement_map'), true) }}"));

        let messages                    =
        {
            /** 車両アイコン吹き出し表示用 */
            v_infobox:                  movement_base.v_infobox,
            /** 地点アイコン吹き出し表示用 */
            d_infobox:                  movement_base.d_infobox,
            /** 車両リスト表示用 */
            infolist1:                  movement_map.infolist1,
            /** 乗務員リスト表示用 */
            infolist2:                  movement_map.infolist2,
            /** 地点リスト表示用 */
            infolist3:                  movement_map.infolist3,
            /** 免許証期限リスト表示用 */
            infolist4:                  movement_map.infolist4,
            /** 地点区分(行先区分) */
            destination_types:          movement_base.destination_types,
            /** エリア区分 */
            destination_areas:          movement_base.destination_areas,
            /** 車両状態 */
            vehicle_status_types:       movement_base.vehicle_status_types,
            /** 実車／空車区分 */
            luggage_status_types:       movement_base.luggage_status_types,
            /** 免許証認証ステータス(1:認証OK、2:NG、3:手入力、null(または0):未認証) */
            license_certification_status_types: movement_base.license_certification_status_types,
            /** 免許証有効期限ステータス(>0:有効期限までの残日数、0:期限日、<0:期限切れ(経過日数)、null:期限日未設定) */
            license_limit_status_types: movement_base.license_limit_status_types,
            /** 情報表示エリア表示・非表示ボタン */
            rightarea_show_button:      movement_map.rightarea_show_button,
            rightarea_hide_button:      movement_map.rightarea_hide_button,
            /** 追尾中ラベル */
            tracking_label:             movement_map.tracking_label,
            /** 追尾中ラベル */
            tracking_reset_button:      movement_map.tracking_reset_button,
            /** 地図の中心位置・倍率設定・解除ボタン */
            map_position_fixed_button:  movement_map.map_position_fixed_button,
            map_position_reset_button:  movement_map.map_position_reset_button,
            /** (地点リスト)エリア欄オプション */
            destination_area_options:   movement_map.search_area3.destination_area_options,
            /** マスタ未登録メッセージ */
            is_not_exists_master_message: movement_base.is_not_exists_master_message,
        };

        let others                      = {
            /** 追尾解除ボタンアイコン */
            img_icon_back:              "{{ asset('storage/img/movement/icon_back_1.png') }}",
        };


        /** 画面初期化処理 */
        let settings                    =
        {
            url_get_movement_map_data:          url_get_movement_map_data,
            url_set_layout_type_data:           url_set_layout_type_data,
            url_temporary_return_list:          url_temporary_return_list,
            url_save_request_behavior_data:     url_save_request_behavior_data,
            url_save_request_video_data:        url_save_request_video_data,
            url_set_default_map_position_data:  url_set_default_map_position_data,
            url_get_destination_areas:          url_get_destination_areas,
            messages:                           messages,
            others:                             others,
        };
        initialize(settings);
    });
}

/* モーダル関連 */
window.navitime_analysis_modal_event_set = function (modalId = 'video-modal')
{
    let timeLineVideo;
    let seekSlider;
    let ichi;
    let duration;
    let nowFrame = 0;
    let frameForwardFlg = false;

    // 再生中フラグ
    let isPlaying = false;

    // 音量設定用
    let volumeNum = 25;
    let isMuted = true;

    // メイン表示になっている動画の番号
    let mainViewNum = 1;

    // 現在の再生速度
    let speedNum = 1.0;

    let vehicleData = [];
    let zMapMain;
    let polylineLociLatlon = [];

    let eventOval;

    // 動画リストを表示するボタン
    $(document).on('click','.warning-list-toggle', function() {
        $('.warning-list-box').toggle();
        let text = $(this).data('text');
        $(this).data('text', $(this).text());
        $(this).text(text);
    });

    // 動画一覧の選択が変更されたらモーダルの内容を更新する
    // 読み込み中は次の選択を送信しない（サーバ側の動画変換が同時に走るのを防ぐ）
    let isWarningListLoading = false;
    $(document).on('change','.warning-list', function() {
        if (isWarningListLoading) return;
        isWarningListLoading = true;
        let selectedOption = $(this).find('option:selected');
        let action = selectedOption.data('action');
        let datas = [
            { name: "record_id", value: selectedOption.data('record_id') },
            { name: "warning_id", value: selectedOption.data('warning_id') }
        ];
        _modal.update(modalId, action, datas, true, function(){
            isWarningListLoading = false;
            setUp();
        }, function(){
            isWarningListLoading = false;
        });
    });

    // 動画再生ボタン
    $(document).on('click','#video-play', function() {
        // play() 中に pause() / DOM 除去で race した場合の AbortError は仕様上の正常応答のため握りつぶす。それ以外のエラー型は通知する
        var swallowAbort = function(err) {
            if (err && err.name !== 'AbortError') {
                console.error(err);
            }
        };
        // 全てのvideoを再生する
        $('.in-vehicle-video').each(function(){
            if (!isPlaying) {
                var p = this.play();
                if (p && typeof p.catch === 'function') p.catch(swallowAbort);
            }
        });
        // Audioタグがある場合にはAudioタグも再生
        if($('#in-vehicle-audio').length) {
            var ap = $('#in-vehicle-audio')[0].play();
            if (ap && typeof ap.catch === 'function') ap.catch(swallowAbort);
        }
        isPlaying = true;
        $('#video-play').css({'display' : 'none'});
        $('#video-pause').css({'display': 'inline-block'});
    });


    // 動画一時停止ボタン
    $(document).on('click','#video-pause', function() {
        // 全てのvideoを一時停止する
        $('.in-vehicle-video').each(function(){
            if (isPlaying) {
                this.pause();
            }
        });
        // Audioタグがある場合にはAudioタグも再生
        if($('#in-vehicle-audio').length) {
            $('#in-vehicle-audio')[0].pause();
        }
        isPlaying = false;
        $('#video-pause').css({'display' : 'none'});
        $('#video-play').css({'display': 'inline-block'});
    });

    // 動画時間、現在時間の表示やスライダーの動作関係など
    $(document).off('shown.bs.modal', '#' + modalId);
    $(document).on('shown.bs.modal', '#' + modalId, function () {
        let alertMessage = $('#alert_message');
        if(alertMessage !== undefined && alertMessage.length > 0) {
            alert($('#alert_message').val());
            _modal.hide('#' + modalId);
        } else {
            setUp();
        }
    });

    // 音声ONボタン
    $(document).on('click','#video-sound-on', function() {
        //音量スライダーの値を設定
        $('#sound-seek-slider').val(volumeNum);
        // 全てのvideoのミュートを取り消す
        $('.in-vehicle-video').each(function(){
            // videoのvolumeは0~1の間でセットするため、100で割った数値をセット
            this.volume  = volumeNum/100;
            this.muted = false;
        });
        // Audioタグがある場合にはAudioタグにも音量を設定
        if($('#in-vehicle-audio').length) {
            $('#in-vehicle-audio')[0].volume  = volumeNum/100;
            $('#in-vehicle-audio')[0].muted = false;
        }
        isMuted = false;
        //サウンドボタンの入れ替え
        $('#video-sound-on').css({'display' : 'none'});
        $('#video-sound-off').css({'display': 'inline-block'});
    });

    // 音声OFFボタン
    $(document).on('click','#video-sound-off', function() {
        //音量スライダーの値を設定
        $('#sound-seek-slider').val(0);
        // 全てのvideoをミュートにする
        $('.in-vehicle-video').each(function(){
            this.muted = true;
        });
        // Audioタグがある場合にはAudioもミュートにする
        if($('#in-vehicle-audio').length) {
            $('#in-vehicle-audio')[0].muted = true;
        }
        isMuted = true;
        //サウンドボタンの入れ替え
        $('#video-sound-off').css({'display' : 'none'});
        $('#video-sound-on').css({'display': 'inline-block'});
    });

    // 音量スライダーを操作したら動画に音量を設定
    $(document).on('input', '#sound-seek-slider', function() {
        volumeNum = $('#sound-seek-slider').val();
        isMuted = false;
        $('.in-vehicle-video').each(function(){
            this.volume = volumeNum/100;
            this.muted = false;
        });
        // Audioタグがある場合にはAudioタグにも音量を設定
        if($('#in-vehicle-audio').length) {
            $('#in-vehicle-audio')[0].volume = volumeNum/100;
            $('#in-vehicle-audio')[0].muted = false;
        }
        if(isMuted == true) {
            $('#video-sound-on').css({'display' : 'none'});
            $('#video-sound-off').css({'display': 'inline-block'});
        }
        isMuted = false;
    });

    // ビデオ用モーダルを閉じた際に動画を止める
    $(document).on('click', '#' + modalId + ' .close', function () {
        $('.in-vehicle-video').each(function(){
            if (isPlaying) {
                this.pause();
            }
        });
        frameForwardFlg = false;
        isPlaying = false;
    });

    // カメラ切り替えボタン
    $(document).on('click', '.camera-select-btn' ,function (e) {
        
        /*---- BS-3868_arata START ----*/
        // 無効化されたボタンはクリックできないようにする
        if ($(this).prop('disabled')) {
            return false;
        }
        /*---- BS-3868_arata END ----*/
        let selectNum = $(this).data('camera-num');
        let mainVideo = $('#main-video')[0];
        let subVideo = $('#sub-video'+selectNum)[0];
        if(selectNum != mainViewNum) {
            // 変更する動画のsrcを取得
            let subSource = $(subVideo).find('source').attr('src');
            // メインビューに選択した動画のsrcをセットし、表示する動画の番号をクラスとして付与
            $(mainVideo).find('source').attr('src', subSource);
            $(mainVideo).removeClass('sub-video'+mainViewNum).addClass('sub-video'+selectNum);
            // 選択したサブ動画を非表示にして停止状態にする
            $('#sub-video'+selectNum).css({'display' : 'none'});
            // メインに表示されていたサブ動画を表示する
            $('#sub-video'+mainViewNum).css({'display': 'inline-block'});
            // 現在メインに表示している動画番号を保持しておく
            mainViewNum = selectNum;
            // メインビューの動画を再ロードする
            mainVideo.load();
            // 再生中だった場合にはメイン動画と表示したサブ動画を再生する
            if (isPlaying) {
                // 現在の描画時間を設定する
                $('#sub-video'+mainViewNum)[0].currentTime = timeLineVideo[0].currentTime;
                mainVideo.currentTime = timeLineVideo[0].currentTime;
                $('#sub-video'+mainViewNum)[0].play();
                mainVideo.play();
            }
            // 現在のボタンを示すクラスを選択したボタンに付与する。
            $('.camera-select-container button').removeClass('btn-primary').addClass('btn-default');
            $(this).removeClass('btn-default').addClass('btn-primary');
        }
    });

    // 再生スピードを指定します（表示調整も含め）
    $(document).on('click', '.speed-select-btn' ,function (e) {
        let playbackRate = $(this).data('speedNum');
        // コマ送り
        if(playbackRate == 0 ){
            if(!frameForwardFlg) {
                let f = Math.floor(timeLineVideo[0].currentTime * 1000) / 1000;
                nowFrame = Math.floor((f / 33.3333333333) * 1000);
            }
            frameForwardFlg = true;
            nowFrame++;
            let nextKeyFrame = (nowFrame * 33.3333333333) / 1000;
            $('.in-vehicle-video').each(function(){
                if (isPlaying) {
                    this.pause();
                }
                this.currentTime = nextKeyFrame;
                this.playbackRate = playbackRate;
            });
            // Audioタグがある場合にはAudioタグの速度も変更
            if($('#in-vehicle-audio').length) {
                $('#in-vehicle-audio')[0].currentTime = nextKeyFrame;
                $('#in-vehicle-audio')[0].playbackRate = playbackRate;
            }
            f = Math.floor( timeLineVideo[0].currentTime * 1000 ) / 1000;
            setMovieTime2(f);
            /** 表示は一時停止のまま再設定しなおす */
            $('#video-play').css({'display' : 'none'});
            $('#video-pause').css({'display': 'inline-block'});
            isPlaying = false;
        }else{
            frameForwardFlg = false;
            $('.in-vehicle-video').each(function(){
                this.playbackRate = playbackRate;
            });
            if(!isPlaying) {
                $('#video-pause').css({'display' : 'none'});
                $('#video-play').css({'display': 'inline-block'});
            }
            // Audioタグがある場合にはAudioタグの速度も変更
            if($('#in-vehicle-audio').length) {
                $('#in-vehicle-audio')[0].playbackRate = playbackRate;
            }
        }
        speedNum = playbackRate;
        $('.speed-select-container button').removeClass('btn-primary').addClass('btn-default');
        $(this).removeClass('btn-default').addClass('btn-primary');
    });

    /**
     * シークバーの位置を設定します。
     * @param {*} f
     */
    function setMovieTime2(f){
        ichi.html(makeMovieTime(f));
    }

    /**
     * 時間（秒数）から、時：分：秒　表記に変更します。
     * @param {*} v
     */
    function makeMovieTime(v){
        let m   = Math.floor(v / 60);
        let s   = ("00" + Math.floor(v - (m * 60))).slice(-2);
        let ret = m + ":" + s;
        if(m >= 60){
            h   = Math.floor(m / 60);
            m   = ("00" + Math.floor(m - (h * 60))).slice(-2);
            ret = h + ":" + m + ":" + s;
        }
        return ret;
    }

    //
    function setUp() {
        vehicleData = $('.zdc-map').data('vehicle_data');
        timeLineVideo = $('#timeline-video');
        seekSlider = $('#video-seek-slider');
        ichi = $("#ichi");
        duration = $('#nagasa').data('duration');
        // スライダーの最大値を設定
        seekSlider.attr('max', duration);
        //スライダーのstep値を設定
        seekSlider.attr('step', duration/1000);
        // 動画時間を分：秒の形式で表示
        $("#nagasa").html(makeMovieTime(Math.floor( duration * 1000 ) / 1000));
        /*---- BS-3868_arata START ----*/
        /*---- カメラボタンの有効/無効を設定 ----*/
        // 各カメラの動画が存在するかチェック
        for (let i = 1; i <= 5; i++) {
            let subVideo = $('#sub-video' + i);
            let source = subVideo.find('source');
            let src = source.attr('src');
            let cameraBtn = $('#camera-select-btn' + i);
            
            // 動画が存在しない場合（srcが空または'empty'）、ボタンを無効化
            if (!src || src === '' || src === 'empty') {
                cameraBtn.prop('disabled', true);
                cameraBtn.addClass('disabled');
            } else {
                cameraBtn.prop('disabled', false);
                cameraBtn.removeClass('disabled');
            }
        }
        /*---- BS-3868_arata END ----*/
        /*---- 地図初期化 ----*/
        zMapMain = $('#' + modalId).find('.zdc-map');
        // modal内の要素の幅、高さを正確に取得するため、モーダル生成1秒後に処理を開始する
        window.setTimeout(function () {
            let options = {
                addressOfMarker: false,
                zoom: 11,
            };
            if (zMapMain.length > 0) {
                //地図を作成
                zMapMain.attr('width', zMapMain.width() + 'px');
                zMapMain.attr('height', zMapMain.height() + 'px');
                if (zMapMain.data('zip_lat') !== '' || zMapMain.data('zip_lon') !== '') {
                    options.lat = zMapMain.data('zip_lat');
                    options.lon = zMapMain.data('zip_lon');
                }
                _zdcMap.Map.init(zMapMain, options, false);
                if(vehicleData.length > 0) {
                    //地図上に経路の線を引く
                    $.each(vehicleData, function(i, item){
                        polylineLociLatlon.push(new ZDC.LatLon(item.latitude, item.longitude));
                    });
                    polylineLoci = new ZDC.Polyline(
                        polylineLociLatlon,
                        {
                            strokeWeight: 3,
                            strokeColor: '#669DF6'
                        }
                    )
                    _zdcMap._zMap.addWidget(polylineLoci);

                    //地図上に開始地点を示すマーカーを描く
                    currentMarker = new ZDC.Marker(
                        new ZDC.LatLon(vehicleData[0].latitude, vehicleData[0].longitude),
                        {
                            offset: new ZDC.Pixel(-25, -25),
                            custom: {
                                base: {
                                    src: '/assets/img/record_data/vehicle_icon.png',
                                }
                            }
                        }
                    );
                    _zdcMap._zMap.addWidget(currentMarker);
                }
            }
        }, 1000);
        timeLineVideo.on('timeupdate', function() {
            // 動画の現在時間が更新されたらスライダーを更新
            seekSlider.val(timeLineVideo[0].currentTime);
            // 動画の現在時間が更新されたら現在時間の内容を更新
            ichi.html(makeMovieTime(Math.floor( timeLineVideo[0].currentTime * 1000 ) / 1000));
            if(vehicleData != undefined && vehicleData.length > 0 && typeof currentMarker !== 'undefined' && currentMarker) {
                let currentFrame = Math.floor((timeLineVideo[0].currentTime / duration) * vehicleData.length);
                //地図移動
                if (currentFrame >= 0 && currentFrame < vehicleData.length) {
                    let currentPosition = vehicleData[currentFrame];
                    //地図の中心を移動
                    _zdcMap.Map.moveLatlon(currentPosition.latitude, currentPosition.longitude);
                    //車両の位置を示す円を移動

                    currentMarker.moveLatLon(new ZDC.LatLon(currentPosition.latitude, currentPosition.longitude));
                }
            }
        });

        // スライダーを操作したら動画の再生位置を更新
        seekSlider.on('input', function() {
            $('.in-vehicle-video').each(function(){
                this.currentTime = seekSlider.val();
            });
            // Audioタグがある場合にはAudioタグの速度も変更
            if($('#in-vehicle-audio').length) {
                $('#in-vehicle-audio')[0].currentTime = seekSlider.val();
            }
        });

        // 動画が終了した際の処理
        timeLineVideo[0].addEventListener("ended", function(){
            frameForwardFlg = false;
            isPlaying = false;
            $('#video-pause').css({'display' : 'none'});
            $('#video-play').css({'display': 'inline-block'});
        }, false);
    }
}